import { FC } from 'react'

import { Size } from '@syconium/little-miss-figgy'

import { StyledVariantSelectionFromSoldOutMessage } from '../../../../../../app/_components/forms/VariantSelectionForm'
import { usePrettySizeName } from '../../../../../../app/_hooks/usePrettySizeName'
import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { trackEvent } from '../../../../../../lib/analytics'

interface Props {
  isProductWaitlistable: boolean
  selectedSize: Size | undefined
  category: string
  hideTitle?: boolean
}

/**
 * @deprecated Use VariantSelectionForm composable components from app directory instead.
 */
export const SizeSelection: FC<Props> = ({
  selectedSize,
  category,
  isProductWaitlistable,
  hideTitle,
}) => {
  const {
    detailsSection: { soldOutSectionTitleMessage },
  } = useTranslation()

  const prettySizeName = usePrettySizeName({
    id: selectedSize?.shorthand,
    displayValue: selectedSize?.shorthand,
  })

  if (!selectedSize || hideTitle) return null
  return (
    <div
      {...trackEvent({
        category,
        action: 'snapshot',
        label: 'size',
        value: selectedSize.shorthand,
      })}
    >
      {prettySizeName}
      {selectedSize.soldOut && !isProductWaitlistable && (
        <StyledVariantSelectionFromSoldOutMessage>
          &nbsp;{soldOutSectionTitleMessage}
        </StyledVariantSelectionFromSoldOutMessage>
      )}
    </div>
  )
}
